import React, { memo } from 'react'
import styles from './AdminLoansDashboardSection.module.scss'
import { BpsAdminDashboardData } from '../../../../model/bps-admin/bps-admin-dashboard-data'

type Props = {
    data?: BpsAdminDashboardData
}

const AdminLoansDashboardSection: React.FC<Props> = memo((props: Props) => {
    const { data } = props

    return (
        <>
            <div className={styles.title}>Loans</div>
            <div className={styles.content}>
                <div className={`${styles.section} ${styles.seperator}`}>
                    <div className={styles.sectionTitle}>Active Loans</div>
                    <div className={styles.sectionContent}>
                        <div>
                            {data?.activeLoans?.toLocaleString()}
                        </div>
                    </div>
                </div>
                <div className={`${styles.section} ${styles.seperator}`}>
                    <div className={styles.sectionTitle}>Defaulting Loans</div>
                    <div className={styles.sectionContent}>
                        <div className={styles.red}>
                            {data?.defaultingLoans?.toLocaleString()}
                        </div>
                    </div>
                </div>
                <div className={styles.section}>
                    <div className={styles.sectionTitle}>Disbursed Loans</div>
                    <div className={styles.sectionContent}>
                        <div className={styles.green}>{data?.disbursedLoans?.toLocaleString()}</div>
                        <div className={styles.currency}>NGN</div>
                    </div>
                </div>
            </div>
        </>
    )
})

export default AdminLoansDashboardSection